import { z } from 'zod/v3';

export const createDeviceSchema = z.object({
  equipment: z.object({
    serial: z.string().min(1, 'Esse campo não pode ser vazio'),
  }),
  product_id: z.string().min(1, 'Esse campo não pode ser vazio'),
});

export const updateDeviceSchema = z.object({
  serial: z.string().min(1, 'Esse campo não pode ser vazio'),
  product_id: z.string().min(1, 'Esse campo não pode ser vazio'),
});

export type CreateDeviceFormData = z.infer<typeof createDeviceSchema>;
export type UpdateDeviceFormData = z.infer<typeof updateDeviceSchema>;
